import HttpClient from './HttpClient';

class AddressAutocompleteService {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  public async calladdressautocomplete({
    freeText,
    captureGroupId,
    captureId,
  }: Record<string, string>): Promise<any> {
    const { COUNTRY, LANGUAGE } = CSS_CONFIG;
    const { error, result } = await this.http.postaddressapi(
      `address/autocomplete`,
      {
        country: COUNTRY,
        language: LANGUAGE,
        freeText: freeText,
        captureGroupId: captureGroupId,
        captureId: captureId,
      }
    );
    if (error) {
      throw error;
    }
    return result;
  }
}

export const addressAutocompleteService = new AddressAutocompleteService(
  new HttpClient()
);
